{
  "version": 1,
  "lines": [
    {
      "code": "cash_and_cash_equivalents",
      "name": "Cash and cash equivalents",
      "statement": "financial_position",
      "classes": [
        "Asset"
      ],
      "ordinal": 0
    },
    {
      "code": "trade_and_other_receivables",
      "name": "Trade and other receivables",
      "statement": "financial_position",
      "classes": [
        "Asset"
      ],
      "ordinal": 1
    },
    {
      "code": "current_tax_assets",
      "name": "Current tax assets",
      "statement": "financial_position",
      "classes": [
        "Asset"
      ],
      "ordinal": 2
    },
    {
      "code": "inventories",
      "name": "Inventories",
      "statement": "financial_position",
      "classes": [
        "Asset"
      ],
      "ordinal": 3
    },
    {
      "code": "other_financial_assets",
      "name": "Other financial assets",
      "statement": "financial_position",
      "classes": [
        "Asset"
      ],
      "ordinal": 4
    },
    {
      "code": "property_plant_and_equipment",
      "name": "Property, plant and equipment",
      "statement": "financial_position",
      "classes": [
        "Asset"
      ],
      "ordinal": 5
    },
    {
      "code": "investment_property",
      "name": "Investment property",
      "statement": "financial_position",
      "classes": [
        "Asset"
      ],
      "ordinal": 6
    },
    {
      "code": "intangible_assets",
      "name": "Intangible assets",
      "statement": "financial_position",
      "classes": [
        "Asset"
      ],
      "ordinal": 7
    },
    {
      "code": "investments_in_associates",
      "name": "Investments in associates",
      "statement": "financial_position",
      "classes": [
        "Asset"
      ],
      "ordinal": 8
    },
    {
      "code": "deferred_tax_assets",
      "name": "Deferred tax assets",
      "statement": "financial_position",
      "classes": [
        "Asset"
      ],
      "ordinal": 9
    },
    {
      "code": "trade_and_other_payables",
      "name": "Trade and other payables",
      "statement": "financial_position",
      "classes": [
        "Liability"
      ],
      "ordinal": 10
    },
    {
      "code": "current_tax_liabilities",
      "name": "Current tax liabilities",
      "statement": "financial_position",
      "classes": [
        "Liability"
      ],
      "ordinal": 11
    },
    {
      "code": "borrowings",
      "name": "Borrowings",
      "statement": "financial_position",
      "classes": [
        "Liability"
      ],
      "ordinal": 12
    },
    {
      "code": "provisions",
      "name": "Provisions",
      "statement": "financial_position",
      "classes": [
        "Liability"
      ],
      "ordinal": 13
    },
    {
      "code": "deferred_tax_liabilities",
      "name": "Deferred tax liabilities",
      "statement": "financial_position",
      "classes": [
        "Liability"
      ],
      "ordinal": 14
    },
    {
      "code": "share_capital",
      "name": "Share capital",
      "statement": "financial_position",
      "classes": [
        "Equity"
      ],
      "ordinal": 15
    },
    {
      "code": "reserves",
      "name": "Reserves",
      "statement": "financial_position",
      "classes": [
        "Equity"
      ],
      "ordinal": 16
    },
    {
      "code": "retained_earnings",
      "name": "Retained earnings",
      "statement": "financial_position",
      "classes": [
        "Equity"
      ],
      "ordinal": 17
    },
    {
      "code": "other_equity",
      "name": "Other equity",
      "statement": "financial_position",
      "classes": [
        "Equity"
      ],
      "ordinal": 18
    },
    {
      "code": "revenue",
      "name": "Revenue",
      "statement": "income",
      "classes": [
        "Income"
      ],
      "ordinal": 100
    },
    {
      "code": "cost_of_sales",
      "name": "Cost of sales",
      "statement": "income",
      "classes": [
        "Expense"
      ],
      "ordinal": 101
    },
    {
      "code": "other_income",
      "name": "Other income",
      "statement": "income",
      "classes": [
        "Income"
      ],
      "ordinal": 102
    },
    {
      "code": "distribution_costs",
      "name": "Distribution costs",
      "statement": "income",
      "classes": [
        "Expense"
      ],
      "ordinal": 103
    },
    {
      "code": "administrative_expenses",
      "name": "Administrative expenses",
      "statement": "income",
      "classes": [
        "Expense"
      ],
      "ordinal": 104
    },
    {
      "code": "other_expenses",
      "name": "Other expenses",
      "statement": "income",
      "classes": [
        "Expense"
      ],
      "ordinal": 105
    },
    {
      "code": "finance_income",
      "name": "Finance income",
      "statement": "income",
      "classes": [
        "Income"
      ],
      "ordinal": 106
    },
    {
      "code": "finance_costs",
      "name": "Finance costs",
      "statement": "income",
      "classes": [
        "Expense"
      ],
      "ordinal": 107
    },
    {
      "code": "income_tax_expense",
      "name": "Income tax expense",
      "statement": "income",
      "classes": [
        "Expense"
      ],
      "ordinal": 108
    }
  ]
}
